import ScheduleActivityRow from "./ScheduleActivityRow";
import ScheduleGroupRow from "./ScheduleGroupRow";

const ScheduleActivityTable = ({ rows = [] }) => {
  const isGrouped = Boolean(rows[0]?.groupBy);

  return (
    <section className="schedule-activities" aria-labelledby="schedule-activities-title">
      <div className="schedule-section-title">
        <div>
          <h3 id="schedule-activities-title">
            {isGrouped ? "Agrupamentos" : "Atividades"}
          </h3>
          <p>
            {isGrouped
              ? "Consolidação das atividades conforme o agrupamento selecionado."
              : "Prioridade calculada pelo desvio, caminho crítico e ausência de medição."}
          </p>
        </div>
      </div>
      {rows.length > 0 ? (
        <div className="schedule-activity-list">
          {rows.map((row) => (
            row.groupBy ? (
              <ScheduleGroupRow
                key={`${row.groupBy}-${row.id ?? row.name}`}
                row={row}
              />
            ) : (
              <ScheduleActivityRow key={row.activityId} row={row} />
            )
          ))}
        </div>
      ) : (
        <p className="schedule-empty">Nenhuma atividade encontrada para este filtro.</p>
      )}
    </section>
  );
};

export default ScheduleActivityTable;
